<template>
   <kye-drawer
    size="514px"
    @opened="onOpen"
    class="layout-custom-banner-drawer"
    :modal="false"
    :withHeader="false"
    :visible.sync="visible"
    :appendToBody="false"
    :direction="'rtl'">
    <div class="layout-custom-banner-drawer-content">
      <DrawerHeader
        :title="title"
        @close="visible = false"  />
      <div class="tab-box-wrapper">
        <div class="tab-nav">
          <span
            v-for="tab in tabList"
            :key="tab.value"
            class="tab-item"
            :class="{'is-active': String(tab.value) === validFlag}"
            @click="onValidFlagChange(tab.value)">
            {{ tab.label }}
          </span>
        </div>
        <div class="tab-box">
          <p v-for="tab in readTabList"
            :class="{'active': tab.value === hasRead}"
            :key="tab.value"
            @click="onReadChange(tab.value)">
            {{tab.label}}
          </p>
        </div>
      </div>
      <query-form :fields="formFields" class="form-box" ref="queryForm" @submit="refresh" v-show="+validFlag === 0" />
      <HistoryBannerList :list="list" @click="onHistoryClick" v-loading="loading" />
      <div class="pagination-footer">
        <kye-pagination
          background
          small
          @current-change="handleCurrentChange"
          :current-page="page"
          :page-size="30"
          layout="total, jumper, prev, pager, next"
          :total="rowTotal">
        </kye-pagination>
      </div>
    </div>
  </kye-drawer>
</template>

<script>
  import moment from 'moment'
  // 抽屉头部
  import DrawerHeader from './drawer-header'
  // 历史记录列表
  import HistoryBannerList from './history-banner-list.vue'
  export default {
    components: { HistoryBannerList, DrawerHeader },
    data() {
      return {
        visible: false,
        loading: false,
        validFlag: '1',
        hasRead: 0,
        title: '历史记录',
        list: [],
        tabList: [
          {label: '显示中', value: 1},
          {label: '已结束', value: 0}
        ],
        page: 1,
        pageSize: 30,
        rowTotal: 0,
        totalObj: {
          allDisplayingCount: 0,
          allEndedCount: 0,
          readedDisplayingCount: 0,
          readedEndedCount: 0,
          unReadDisplayingCount: 0,
          unReadEndedCount: 0
        },
        readTabList: [
          {label: '全部', value: 2},
          {label: '未读', value: 0},
          {label: '已读', value: 1},
        ],
        formFields: [
          {
            'propertyName': 'date',
            'columnType': 'string',
            // 'operation': 'equal',
            'label': '开始时间',
            'show': true,
            'type': 'datePicker',
            // 'format': 'yyyy-MM-DD',
            'dateType': 'daterange', // el-date-picker 组件 type 属性
            'width': 120 // 有内置宽度，不生效
          },
          {
            'propertyName': 'name',
            'columnType': 'string',
            'label': '标题',
            'placeholder': '',
            'openPlaceholder': true,
            'type': 'text',
            'show': true,
            'width': 120
          },
        ]
      }
    },
    methods: {
      open () {
        this.visible = true
      },
      async onOpen () {
        await this.initTotal()
        this.initTitle()
        this.initList()
      },
      onHistoryClick (data, list) {
        this.$emit('click', data, list)
      },
      onValidFlagChange (val) {
        const nextFlag = String(val)
        if (nextFlag !== this.validFlag) {
          this.validFlag = nextFlag
          this.refresh()
        }
      },
      onReadChange (val) {
        if (val !== this.hasRead) {
          this.hasRead = val
          this.refresh()
        }
      },
      initTitle () {
        let total = 0
        if (this.hasRead === 2) {
          total = this.totalObj.allDisplayingCount + this.totalObj.allEndedCount
        }
        if (this.hasRead === 1) {
          total = this.totalObj.readedDisplayingCount + this.totalObj.readedEndedCount
        }
        if (this.hasRead === 0) {
          total = this.totalObj.unReadDisplayingCount + this.totalObj.unReadEndedCount
        }
        this.title = `历史记录 (${total})`
      },
      async initTotal () {
        const res = await this.$http('kuasheng.appsManager.ksApplicationAdv.countErpHomePageAdvHis', {}, {appkey: '10184'})
        this.totalObj = res
        // 展示顺序优先展示未读 ，然后是全部
        if (res.unReadDisplayingCount || res.unReadEndedCount) {
          this.hasRead = 0
          this.validFlag = res.unReadDisplayingCount ? '1' : '0'
        } else {
          this.hasRead = 2
          if (res.allDisplayingCount) {
            this.validFlag = '1'
          } else if (res.allEndedCount) {
            this.validFlag = '0'
          } else {
            this.validFlag = '1'
          }
        }
      },
      async initList () {
        try {
          this.loading = true
          const {date = [], name = ''} = this.$refs.queryForm && (+this.validFlag === 0) ? this.$refs.queryForm.getModel() : {}
          const params = {
            hasRead: this.hasRead === 2 ? '' : this.hasRead,
            startDate: date[0] ? moment(date[0]).format('YYYY-MM-DD') : '',
            endDate: date[1] ? moment(date[1]).format('YYYY-MM-DD') : '',
            name,
            validFlag: this.validFlag
          }
          if (+this.validFlag === 0) {
            params.page = this.page
            params.pageSize = this.pageSize
          } else {
            params.page = this.page
            params.pageSize = this.pageSize
          }
          let {rows = [], rowTotal = 0} = await this.$http('kuasheng.ksApplicationAdv.getErpHomePageAdvHisList', params, {appkey: '10184'})
          // 如果是显示中,需要前端自己根据日期过滤下
          if (+this.validFlag === 1) {
            rows = rows.filter(item => item.startTime < new Date().getTime())
          }
          const list = rows.map(item => {
            item.creationDate = moment(item.creationDate).format('YYYY-MM-DD HH:mm')
            return item
          })
          this.list = list
          this.rowTotal = rowTotal
          this.loading = false
        } catch (error) {
          this.loading = false
        }
      },
      refresh () {
        this.page = 1
        this.initTitle()
        this.initList()
      },
      handleCurrentChange (val) {
        this.page = val
        this.initList()
      }
    }
  }
</script>

<style lang="scss" scoped>
.layout-custom-banner-drawer {
  top: 78px !important;
  /deep/ .el-drawer {
    box-shadow: 0 16px 18px -5px rgba(0, 0, 0, 0.3);
  }

  &-content {
    display: flex;
    flex-direction: column;
    height: 100%;
  }
  .form-box {
    padding: 10px 16px;
    /deep/ .el-button--primary  {
      background: rgba(109, 46, 248, 1);
    }
  }
  .tab-box-wrapper {
    display: flex;
    padding: 18px 16px 4px 0;
    align-items: center;
    justify-content: space-between;
  }
  .tab-nav {
    display: flex;
    flex: 1;
    overflow: hidden;
    flex-shrink: 0;
    gap: 24px;
    padding-left: 16px;
    padding-bottom: 6px;
    // border-bottom: 1px solid rgba(224, 223, 239, 0.6);
    .tab-item {
      position: relative;
      flex-shrink: 0;
      font-size: 13px;
      color: #1d1c23;
      line-height: 30px;
      height: 30px;
      cursor: pointer;
      box-sizing: border-box;
      transition: color 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
      &::after {
        content: '';
        position: absolute;
        left: 0;
        right: 0;
        bottom: -6px;
        height: 2px;
        background-color: transparent;
      }
      &.is-active {
        color: #8757f9;
        font-weight: 700;
        &::after {
          background-color: #8757f9;
        }
      }
    }
  }
  .tab-box {
    width: 180px;
    height: 28px;
    background: #F1F2F9; // theme
    border-radius: 14px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 2px;
    box-sizing: border-box;
    > p {
      font-size: 12px;
      color: #888EA6;
      text-align: center;
      flex: 1;
      cursor: pointer;
      &.active {
        background: #ffffff;
        color: var(--g-color-primary);
        border-radius: 12px;
        box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.06);
        line-height: 24px;
      }
    }
  }
  .pagination-footer {
    height: 60px;
    align-items: center;
    display: flex;
    justify-content: flex-end;
    padding: 0 16px;
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/pages/home/drawer/index.vue